@Component( 'ib-ancillaries-banner', 'ibResidentBaggageBanner', {
    bindings: {
    },
    controllerAs: 'ibResidentBaggageBannerCtrl',
    templateUrl: ['$rootScope', ($rootScope: CommonsRootScope):string => {
        return `${$rootScope.routes.templates}ib-resident-baggage-banner.html`;

    }]
}, [], [] )
class ibResidentBaggageBannerComponent implements ng.IController {
    constructor () {
    }
}